import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../Global/axios";
import { sortByName } from "../../utils/sortByName";

const getClientData = createAsyncThunk("api/client", async (token) => {
  try {
    const response = await axios.get("/dashboard/client", {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data.data;
  } catch (e) {
    throw new Error(e.message);
  }
});

const ClientDataSlice = createSlice({
  name: "client",
  initialState: {
    data: null,
    error: "",
    status: false,
    isLoading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getClientData.fulfilled, (state, action) => {
        state.data = sortByName(action.payload);
        state.isLoading = false;
        state.status = true;
      })
      .addCase(getClientData.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getClientData.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      });
  },
});

export { getClientData };
export default ClientDataSlice.reducer;
